<template>
  <div>
    <el-form-item label="原文">
      <PinyinInput v-model="subjectPinyin" :text="subject" :uppercase="true" type="textarea" :autosize="{minRows:1}" resize="none"></PinyinInput>
      <el-input v-model="subject" type="textarea" :autosize="{minRows:1}" resize="none" style="margin-top:5px;"></el-input>
      <PinyinPreview :text="subject" :pinyin="subjectPinyin" popover></PinyinPreview>
    </el-form-item>
    <el-form-item label="答案音频" v-if="config.answerAudio">
      <FileInput v-model="form.answerAudio" accept="audio/*"></FileInput>
    </el-form-item>
    <ShowAnswer v-model="form" :config="config"></ShowAnswer>
  </div>
</template>

<script>
  import dialog from '@/components/mixins/dialog.js'
  import ShowAnswer from "./ShowAnswer"
  import PinyinInput from "@/components/PinyinInput"
  import PinyinPreview from "@/components/PinyinPreview"
  export default {
    name: 'ZctForm',
    components: {
      FileInput: require('@/components/FileInput').default,
      ShowAnswer, PinyinInput, PinyinPreview
    },
    mixins: [dialog],
    props: {
      config: {},
      model: {}
    },
    data () {
      return {
        subject: '',
        subjectPinyin: '',
        form: this.normalizedModel(this.model)
      }
    },
    watch: {
      model (val) {
        this.form = this.normalizedModel(val)
        this.initSubject()
      }
    },
    mounted () {
      this.initSubject()
    },
    methods: {
      normalizedModel (model) {
        let val = Object.assign({}, model)
        return val
      },
      splitText(text) {
        return text ? text.split(' ') : []
      },
      initSubject() {
        if (!this.form) {
          this.subject = ''
          this.subjectPinyin = ''
        }
        let subjectParts = this.splitText(this.form.subject)
        let subjectPinyinParts = this.splitText(this.form.subjectPinyin)
        if (this.form.answers) {
          this.form.answers.forEach(n => {
            if (subjectParts.length > n.position) {
              subjectParts[n.position] += '=' + n.text
            }
            if (subjectPinyinParts.length > n.position) {
              subjectPinyinParts[n.position] += '=' + n.pinyin
            }
          })
        }
        this.subject = subjectParts.join(' ')
        this.subjectPinyin = subjectPinyinParts.join(' ')
      },
      getFormData() {
        let data = Object.assign({}, this.form, {
          subject: this.subject,
          subjectPinyin: this.subjectPinyin
        })
        this.handleDialogText(data, 'subject', 'subjectPinyin')
        let answers = []
        let subjectParts = this.splitText(data.subject)
        let subjectPinyinParts = this.splitText(data.subjectPinyin)
        subjectParts.forEach((s, n) => {
          if (/=/.test(s)) {
            let parts = s.split('=')
            let answer = {
              text: parts[1],
              pinyin: '',
              position: n,
            }
            subjectParts[n] = parts[0]
            if (subjectPinyinParts.length > n) {
              let pinyin = subjectPinyinParts[n]
              if (/=/.test(pinyin)) {
                parts = pinyin.split('=')
                answer.pinyin = parts[1]
                subjectPinyinParts[n] = parts[0]
              }
            }
            answers.push(answer)
          }
        })
        data.subject = subjectParts.join(' ')
        data.subjectPinyin = subjectPinyinParts.join(' ')
        data.answers = answers
        return data
      }
    }
  }
</script>
